var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"bg-gray-200 rounded mt-1 p-1",attrs:{"options":_vm.classConfigurationTemplates,"reduce":option => option.class_config,"label":"show_template_identifier","clearable":false},on:{"input":_vm.configSelected},model:{value:(_vm.selectedConfig),callback:function ($$v) {_vm.selectedConfig=$$v},expression:"selectedConfig"}})
}
var staticRenderFns = []

export { render, staticRenderFns }